import { useCallback, useEffect, useState } from 'react';
import classnames from 'classnames';
import { object, string } from 'yup';

import styles from '../redeem-gift-card.module.scss';
import Input from '../../../components/input/input';
import NidInput from '../../../components/nid-input/nid-input';
import Button from '../../../components/button/button';
import Card from '../../../components/card/card';
import { GiftCardUser } from '../types';

type Props = {
    currentStep: number;
    onContinue: (user: GiftCardUser) => void;
};

const schema = object({
    fullName: string()
        .min(3, 'Mínimo 3 caracteres')
        .required('Nombre completo requerido'),
    email: string()
        .email('Correo electrónico inválido')
        .required('Correo electrónico requerido'),
    phone: string().min(7, 'Mínimo 7 dígitos').required('Teléfono requerido'),
    nid: string()
        .min(3, 'Mínimo 3 caracteres')
        .required('Cédula o pasaporte requerido'),
});

const BeneficiaryCard = ({ currentStep, onContinue }: Props) => {
    const [user, setUser] = useState<GiftCardUser>({
        fullName: '',
        email: '',
        phone: '',
        nid: '',
    });
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        setDisabled(!schema.isValidSync(user));
    }, [user]);

    const onInput: (attr: string, value: string) => void = (attr, value) => {
        setUser({ ...user, [attr]: value });
    };

    const handleContinue: () => void = useCallback(() => {
        onContinue(user);
    }, [user]);

    return (
        <Card
            className={classnames({
                [styles.overshadowed]: currentStep !== 2,
                [styles.card]: true,
                [styles.beneficiaryCard]: true,
                [styles.shown]: currentStep === 2,
            })}
        >
            <header>
                <h4>Beneficiario</h4>
                <span className={styles.content}>
                    Introduce los datos del beneficiario de esta Gift Card
                </span>
            </header>
            <form>
                <Input
                    placeholder="Nombre completo"
                    onInput={(value) => onInput('fullName', value)}
                />
                <Input
                    placeholder="Correo electrónico"
                    onInput={(value) => onInput('email', value)}
                />
                <NidInput
                    placeholder="Cédula o pasaporte"
                    onInput={(value) => onInput('nid', value)}
                />
                <Input
                    placeholder="Teléfono celular"
                    onInput={(value) => onInput('phone', value)}
                />
            </form>
            <Button
                disabled={disabled}
                text="Continuar"
                onClick={handleContinue}
            />
        </Card>
    );
};

export default BeneficiaryCard;
